import type { ContactInfo, ContactSubmission } from '@sshop/domain';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import { contactListDto } from './contact.dto';

export interface ContactService {
  list(signal?: AbortSignal): Promise<readonly ContactInfo[]>;
  submit(input: ContactSubmission, signal?: AbortSignal): Promise<void>;
}

export function createLaravelContactService(transport: Transport): ContactService {
  return {
    async list(signal): Promise<readonly ContactInfo[]> {
      const res = await transport.request({
        method: 'GET',
        path: '/contacts',
        ...(signal !== undefined ? { signal } : {}),
      });
      const parsed = parseDto(contactListDto, res.data, 'GET /contacts');
      return parsed.data.map((c) => ({
        id: c.id,
        phone: c.phone,
        email: c.email,
        workingHours: c.working_hours,
        address: c.address,
        city: c.city,
        country: c.country,
      }));
    },
    async submit(input, signal): Promise<void> {
      await transport.request({
        method: 'POST',
        path: '/contact',
        body: {
          name: input.name,
          email: input.email,
          phone: input.phone ?? '',
          message: input.message,
        },
        ...(signal !== undefined ? { signal } : {}),
      });
    },
  };
}
